import request from "@utils/request"

export function postRefundList(data) {
    return request({
        url: '/service/mg/sale/claimDemage/refund/list',
        method: 'POST',
        data,
    })
}

export function postRefundDispose(data) {
    return request({
        url: '/service/mg/sale/claimDemage/refund/dispose',
        method: 'POST',
        data,
    })
}

//财管管理-订单统计（列表）
export function postOrderStatisticsList(data) {
    return request({
        url: '/service/mg/sale/po/query-statistics-list',
        method: 'POST',
        data,
    })
}

//财管管理-查询服务国家（列表）
export function postServiceCountryList(data) {
    return request({
        url: '/service/mg/sale/po/query-transaction-service-country',
        method: 'POST',
        data,
    })
}

//财管管理-统计客户明细详情
export function postOrderStatisticsDetail(data) {
    return request({
        url: '/service/mg/sale/po/query-statistics-detail',
        method: 'POST',
        data,
    })
}


//集柜单文件管理
export function postQueryUploadContainerFile(data) {
    return request({
        url: '/service/mg/container/query-upload-container-file',
        method: 'POST',
        data,
    })
}

//上传集柜单文件
export function postDoUploadContainer(data) {
    return request({
        url: '/service/mg/container/do-upload-container',
        method: 'POST',
        data,
    })
}
